import { render, staticRenderFns } from "./activity-concepts-modal.vue?vue&type=template&id=201246fe&scoped=true&"
import script from "./activity-concepts-modal.ts?vue&type=script&lang=ts&"
export * from "./activity-concepts-modal.ts?vue&type=script&lang=ts&"
import style0 from "./activity-concepts-modal.scss?vue&type=style&index=0&id=201246fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201246fe",
  null
  
)

export default component.exports